module.exports = __webpack_public_path__ + "02_short_black.402f6aad.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/02_short_black.png
// module id = Anub
// module chunks = 0